import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5808ea6d"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "block"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "d", -1));

const _hoisted_3 = {
  class: "block"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_count_down = _resolveComponent("van-count-down");

  return _openBlock(), _createBlock(_component_van_count_down, {
    time: $props.time
  }, {
    default: _withCtx(timeData => [_createElementVNode("span", _hoisted_1, _toDisplayString(timeData.days), 1), _hoisted_2, _createElementVNode("span", _hoisted_3, _toDisplayString(timeData.hours), 1), _createElementVNode("small", null, "h " + _toDisplayString($props.state), 1)]),
    _: 1
  }, 8, ["time"]);
}